"use client";

import Image from "@/components/Image";
import React, { useState } from "react";

const BottomH5 = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [show, setShow] = useState(false);
  const [openSections, setOpenSections] = useState({
    about: false,
    school: false,
    service: false,
  });
  const toggleSection = (section: keyof typeof openSections) => {
    setOpenSections((prev: typeof openSections) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const sections = [
    {
      key: "about" as const,
      title: "关于",
      links: [
        { href: "/aboutus", text: "关于蜜蜂家校" },
        {
          href: "https://static-cdn-p.mifengjiaoyu.com/policy/mifengjiaxiao_web/service_zh-cn.html",
          text: "用户协议",
          target: true,
        },
        {
          href: "https://static-cdn-p.mifengjiaoyu.com/policy/mifengjiaxiao_web/privacy_zh-cn.html",
          text: "隐私政策",
          target: true,
        },
      ],
    },
    {
      key: "school" as const,
      title: "我是校方",
      links: [
        {
          href: "https://xy.mifengjiaoyu.com/login",
          text: "校园版操作平台",
          target: true,
        },
        {
          href: "https://mifengjiaoyu.feishu.cn/wiki/MaHXwo0USiWsrhkSLMTcHYTsnfb",
          text: "新手指南",
        },
      ],
    },
    {
      key: "service" as const,
      title: "我是服务商",
      links: [
        {
          href: "https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1",
          text: "代理合作",
          target: true,
        },
      ],
    },
  ];

  return (
    <section className="w-full h-auto w-min-[768px] bg-[#333333] px-[20px] ">
      <div className="w-full h-auto py-[80px] flex flex-col items-center gap-[40px]">
        {/*内容*/}
        <div className="w-full flex flex-col gap-[40px]">
          <div className="w-full flex flex-row gap-[100px] [@media(max-width:660px)]:gap-[60px]">
            {/*蜜蜂家校*/}
            <div className="w-full flex flex-col gap-[10px]">
              <div className="w-[132px] h-[34px]">
                <Image
                  src="/logo_10.png"
                  alt="蜜蜂试卷"
                  width={132}
                  height={34}
                  className=""
                />
              </div>
              <div className=" font-light text-[14px] leading-[24px] tracking-[0px] text-[#FFF]">
                蜜蜂家校是一个提供一站式 AI
                技术赋能教与学解决方案落地的平台，产品包含多样化作业管理、AI
                精准学情分析、全场景家校沟通等，旨在投身教育，终身学习，成就不同精彩人生。
              </div>
            </div>
            {/*右侧图片*/}
            <div className="w-[159px] h-[220px] relative flex items-center justify-center">
              {/* 放大后的图片（默认隐藏） */}
              {isClicked && (
                <>
                  {/* 蒙层 - 点击时关闭弹窗 */}
                  <div
                    className="fixed inset-0 z-40 bg-[rgba(0,0,0,0.6)]"
                    onClick={() => setIsClicked(false)}
                  />
                  <div className="fixed w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 max-w-[80%] shadow-xl rounded-lg overflow-hidden">
                    <Image
                      src="/education_hover_10.png"
                      alt="教育应用备案大图"
                      width={682}
                      height={224}
                    />
                  </div>
                </>
              )}
              <div onClick={() => setIsClicked(!isClicked)} className="">
                <Image
                  src="/education_filing_10.png"
                  alt="教育应用备案小图"
                  width={159}
                  height={220}
                />
              </div>
            </div>
          </div>
          {/*三个折叠框*/}
          <div className="w-full flex flex-col gap-[10px]">
            {sections.map((section) => (
              <div
                key={section.key}
                className="w-full flex flex-col gap-[10px]"
              >
                <div
                  className="h-[44px] flex items-center justify-between cursor-pointer font-[PingFang-SC] font-semibold text-[24px] leading-[34px] tracking-[0px] text-[#FFFFFF]"
                  onClick={() => toggleSection(section.key)}
                >
                  <span>{section.title}</span>
                  <svg
                    className={`w-[20px] h-[20px] transition-transform ${
                      openSections[section.key] ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openSections[section.key]
                      ? "h-full opacity-100"
                      : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="flex flex-col gap-[10px]">
                    {section.links.map((link, index) => (
                      <a
                        key={index}
                        href={link.href}
                        {...(link.target && {
                          target: "_blank",
                          rel: "noopener noreferrer nofollow",
                        })}
                        className="h-[28px] font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF]"
                      >
                        {link.text}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/*备案信息*/}
        <div className="w-full flex flex-col gap-[24px]">
          <div className="font-[PingFang-SC] font-normal text-[14px] leading-[24px] tracking-[0px] text-[#FFFFFF73]">
            上海临冠数据科技有限公司
            <br />
            公司地址：上海市静安区万荣路1268号云立方A座11层
            <br />
            违法和不良信息举报电话：021-26022790
          </div>
          <div className="font-[PingFang-SC] font-normal text-[14px] leading-[24px] tracking-[0px] text-[#FFFFFF73]">
            <div>版权所有 ©上海临冠数据科技有限公司</div>
            <div className="w-full">
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                rel="noopener noreferrer"
                className="mr-[20px]"
              >
                沪 ICP备18021381号-7
              </a>
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch"
                target="_blank"
                rel="noopener noreferrer"
                className="mr-[20px]"
              >
                沪公网安备 31010602006688号
              </a>
            </div>
          </div>

          <div className="relative inline-block">
            <Image
              src="/pic1_xy_04.png"
              alt="营业执照"
              width={74}
              height={24}
              className="block cursor-pointer"
              onClick={() => setShow(true)}
            />
            {show && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center"
                style={{ background: "rgba(0,0,0,0.6)" }}
                onClick={() => setShow(false)}
              >
                <div
                  className="bg-white rounded-lg overflow-hidden"
                  style={{ width: "80vw", maxWidth: 1109 }}
                  onClick={(e) => e.stopPropagation()} // 阻止冒泡，点击内容不关闭
                >
                  <Image
                    src="/pic2_xy_04.png"
                    alt="弹窗图片"
                    width={1109}
                    height={767}
                    className="w-full h-auto"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomH5;
